import { Button, Field, Input } from "@nodus/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import * as React from "react";
import { AuthCard, PASSWORD_RULE, passwordProblem } from "../../../app/auth-card";
import { useAuth } from "../../../auth/auth-context";

export const Route = createFileRoute("/reset-password")({ component: ResetPassword });

function ResetPassword() {
  const { auth, session } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState<string>();
  if (!session) {
    return (
      <AuthCard title="This link has expired" description="Reset links work once and expire. Request a new one to continue.">
        <Button onClick={() => navigate({ to: "/forgot-password" })}>Request a new link</Button>
      </AuthCard>
    );
  }
  return (
    <AuthCard title="Choose a new password">
      <form
        className="grid gap-4"
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await auth.updatePassword(password);
            void navigate({ to: "/" });
          } catch (err) {
            setError(err instanceof Error ? err.message : "Could not update the password.");
          }
        }}
      >
        <Field id="password" label="New password" hint={PASSWORD_RULE} error={error ?? (password ? passwordProblem(password) : undefined)} required>
          <Input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Button type="submit" disabled={!!passwordProblem(password)}>Update password</Button>
      </form>
    </AuthCard>
  );
}
